export default "__VITE_ASSET__CENG$mit__"